module.exports = __webpack_public_path__ + "img/QuickBooks.fba85bfe.svg";